import React, { useState, useContext, useEffect } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

import api from "services/api";

import qs from "query-string";
import toast from "react-hot-toast";

import Error404 from "pages/error/404";
import ProductDetailModal from "pages/de/portfolio/components/ProductDetailModal";
import ImportSingleStyleModal from "pages/de/portfolio/components/ImportSingleStyleModal";
import ImportSingleCollectionModal from "pages/de/portfolio/components/ImportSingleCollectionModal";

import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";

import Template1 from "pages/de/portfolio/components/template1";
import Template2 from "pages/de/portfolio/components/template2";
import Template3 from "pages/de/portfolio/components/template3";

const Portfolio = ({ editable = false }) => {
  const [templateIndex, setTemplateIndex] = useState("layout_1");
  const [anchorEl, setAnchorEl] = useState(null);
  const [productDetailVisible, setProductDetailVisible] = useState(false);

  const [selectedProductId, setSelectedProductId] = useState("");
  const [importStyleVisible, setImportStyleVisible] = useState(false);
  const [importCollectionVisible, setImportCollectionVisible] = useState(false);

  const [menuVisible, setMenuVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({});
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [selectedImg, setSelectedImg] = useState({});
  const [userData, setUserData] = useState({}); //retrieve user data by give handle
  const [imgsViewerVisible, setImgsViewerVisible] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);

  const { store } = useContext(StoreContext);
  const account = useContext(AccountContext);

  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const handle = params?.handle; //if contains handle then it is the website public to all, other wise, it is a portfolio edit page
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const isPreview = urlObj?.query?.preview;

  let portfolioData = account?.metadata?.portfolio_content || {};
  let storeData = store;
  if (handle) {
    portfolioData = userData?.metadata?.portfolio_content || {};
    storeData = userData?.stores?.[0] || {};
  }
  let collectionStyleList = portfolioData["col_0"] || [];
  let featuredStyleList = portfolioData["style_0"] || [];

  const handleClickProduct = (product) => {
    setSelectedProductId(product?.id);
    setProductDetailVisible(true);
  };

  useEffect(() => {
    if (account.id) {
      handleRefresh();
    }
  }, [account.id]);

  const handleCloseTemplateMenu = () => setAnchorEl(null);
  const TemplateMenu = () => (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleCloseTemplateMenu}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      <MenuItem
        onClick={() => {
          handleChangeTemplate("layout_1");
          handleCloseTemplateMenu();
        }}
      >
        Layout 1
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleChangeTemplate("layout_2");
          handleCloseTemplateMenu();
        }}
      >
        Layout 2
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleChangeTemplate("layout_3");
          handleCloseTemplateMenu();
        }}
      >
        Layout 3
      </MenuItem>
    </Menu>
  );

  const handleChangeTemplate = async (templateName) => {
    setTemplateIndex(templateName);

    if (account.id) {
      let payload = {
        metadata: {
          ...account?.metadata,
          portfolio_layout: templateName,
        },
      };
      try {
        const { data } = await api.account.update(account.id, payload);
        handleRefresh();
        setImportStyleVisible(false);
        toast.success("Change portfolio template successfully!");
      } catch (err) {
        console.log(err);
        toast.error("Change portfolio template failed!");
      }
    } else {
      toast.error("Can't find the user!");
    }
  };

  const handleRefresh = async () => {
    if (handle) {
      const userProfile = await api.users.retrieve(handle);
      if (userProfile?.data?.user) {
        setUserData(userProfile?.data?.user);
        const templateName = userProfile?.data?.user?.metadata?.portfolio_layout || "layout_1";
        setTemplateIndex(templateName);
        setIsNotFound(false);
      } else {
        setIsNotFound(true);
      }
    } else {
      try {
        const mySelf = await account.handleRefresh();
        setUserData(mySelf?.user || {});
        const templateName = mySelf?.user?.metadata?.portfolio_layout || "layout_1";
        setTemplateIndex(templateName);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleCloseStyleImportMenu = () => setMenuVisible(false);

  const StyleImportMenu = () => (
    <Menu
      id="style-import-menu"
      open={menuVisible}
      onClose={handleCloseStyleImportMenu}
      anchorReference="anchorPosition"
      anchorPosition={{ top: mousePosition?.clientY + 4, left: mousePosition?.clientX + 4 }}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      {selectedSlot != "profile" ? (
        <MenuItem
          onClick={() => {
            setImportStyleVisible(true);
            handleCloseStyleImportMenu();
          }}
        >
          Import Style
        </MenuItem>
      ) : null}
    </Menu>
  );

  const handleClickItem = (e, slot, item) => {
    if (handle) {
      if (item?.img) {
        setSelectedImg(item.img);
        //setImgsViewerVisible(true);
        handleClickProduct(item);
      }
    } else {
      if (!slot.startsWith("col")) {
        //using cursor location instead of element position
        setMousePosition({ clientX: e.clientX, clientY: e.clientY });
        setMenuVisible(true);
        setSelectedSlot(slot);
      }
    }
  };

  const onSortEnd = async (oldIndex, newIndex, slot) => {
    if (!slot) {
      return;
    }
    //setItems((array) => arrayMove(array, oldIndex, newIndex));
    let portfolioData = account?.metadata?.portfolio_content || {};

    let list = portfolioData[slot] || [];

    if (list.length > 0) {
      var updatedList = [...list];
      // Remove dragged item
      const [reorderedItem] = updatedList.splice(oldIndex, 1);
      updatedList.splice(newIndex, 0, reorderedItem);

      let old_portfolio = account?.metadata?.portfolio_content || {};
      old_portfolio[slot] = updatedList;

      let payload = {
        metadata: {
          ...account?.metadata,
          portfolio_content: {
            ...old_portfolio,
          },
        },
      };

      try {
        const { data } = await api.account.update(account.id, payload);
        handleRefresh();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleImportCollection = async (selectedCollection, selectedStyleImgs) => {
    if (account.id) {
      let old_portfolio = account?.metadata?.portfolio_content || {};
      let slot_name = "col_0";

      if (!old_portfolio[slot_name]) {
        old_portfolio[slot_name] = [];
      }
      for (let i = 0; i < selectedStyleImgs.length; i++) {
        old_portfolio[slot_name].push({
          img: selectedStyleImgs[i]?.img,
          id: selectedStyleImgs[i]?.id,
          type: "collection",
          title: selectedStyleImgs[i]?.title,
          cid: selectedCollection?.id,
          ctitle: selectedCollection?.title,
        });
      }

      let payload = {
        metadata: {
          ...account?.metadata,
          portfolio_content: old_portfolio,
        },
      };
      try {
        const { data } = await api.account.update(account.id, payload);
        handleRefresh();
        setImportCollectionVisible(false);
      } catch (err) {
        console.log(err);
        toast.error("Import collection to portfolio failed!");
      }
    } else {
      toast.error("Can't find the user!");
    }
  };
  const handleShowImportCollection = () => setImportCollectionVisible(true);

  const allTemplates = {
    layout_1: {
      label: "Layout 1",
      value: (
        <Template1
          userData={userData}
          handle={handle}
          handleClickProduct={handleClickProduct}
          handleRefresh={handleRefresh}
          onSortEnd={onSortEnd}
          handleImportCollection={handleImportCollection}
          handleShowImportCollection={handleShowImportCollection}
          handleClickItem={handleClickItem}
        />
      ),
    },
    layout_2: {
      label: "Layout 2",
      value: (
        <Template2
          userData={userData}
          handle={handle}
          handleClickProduct={handleClickProduct}
          handleRefresh={handleRefresh}
          onSortEnd={onSortEnd}
          handleImportCollection={handleImportCollection}
          handleShowImportCollection={handleShowImportCollection}
          handleClickItem={handleClickItem}
        />
      ),
    },
    layout_3: {
      label: "Layout 3",
      value: (
        <Template3
          userData={userData}
          handle={handle}
          handleClickProduct={handleClickProduct}
          handleRefresh={handleRefresh}
          onSortEnd={onSortEnd}
          handleImportCollection={handleImportCollection}
          handleShowImportCollection={handleShowImportCollection}
          handleClickItem={handleClickItem}
        />
      ),
    },
  };

  if (!editable && !handle) {
    return <Error404 />;
  }

  if (isNotFound) {
    return <Error404 />;
  }

  return (
    <SuiBox>
      <SuiBox display="flex" justifyContent="flex-end">
        {handle ? null : (
          <SuiBox display="flex" gap={1} alignItems="center">
            <SuiButton
              variant="gradient"
              color={"info"}
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(e.currentTarget);
              }}
            >
              {allTemplates[templateIndex]?.label}
              <ArrowDropDownIcon />
            </SuiButton>
            <SuiButton
              variant="gradient"
              color={"light"}
              component={Link}
              to={`/portfolio/${account.id}?preview=true`}
            >
              Preview
            </SuiButton>
          </SuiBox>
        )}
        {isPreview ? (
          <SuiButton variant="gradient" color={"light"} onClick={() => navigate(-1)} size="medium">
            <ArrowBackIcon sx={{ mr: 0.5 }} />
            Back
          </SuiButton>
        ) : null}

        <TemplateMenu />
      </SuiBox>
      <SuiBox>{allTemplates[templateIndex]?.value}</SuiBox>

      {productDetailVisible && selectedProductId ? (
        <ProductDetailModal
          visible={productDetailVisible}
          handleClose={() => setProductDetailVisible(false)}
          productId={selectedProductId}
        />
      ) : null}

      <StyleImportMenu />
      {importStyleVisible ? (
        <ImportSingleStyleModal
          handleClose={() => setImportStyleVisible(false)}
          visible={importStyleVisible}
          isEdit={false}
          categoryTree={[]}
          collection={null}
          handleRefresh={() => {
            handleRefresh();
          }}
          handleOk={handleOk}
        />
      ) : null}
      {importCollectionVisible ? (
        <ImportSingleCollectionModal
          handleClose={() => setImportCollectionVisible(false)}
          visible={importCollectionVisible}
          isEdit={false}
          handleRefresh={() => {
            handleRefresh();
          }}
          handleOk={handleImportCollection}
        />
      ) : null}
      <Lightbox
        open={imgsViewerVisible}
        close={() => setImgsViewerVisible(false)}
        slides={[{ src: selectedImg.url, id: 0 }]}
        plugins={[Zoom, Download]}
        zoom={{ maxZoomPixelRatio: 3 }}
        index={0}
      />
    </SuiBox>
  );
};

export default Portfolio;
